import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useCourierShift, loadShift, resetShift } from '../utils/courierShift';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Kuryer mobil ilovada (Flutter WebView) smenasini BOSHLAGANDA — native tomonga fon
// GPS kuzatuvini yoqishni aytadi (har ~3 daqiqada nuqta /api/courier-tracking/points
// ga yuboriladi). Smena tugaganda, chiqib ketganda yoki kuryer bo'lmasa — o'chiradi.
// Oddiy brauzerda (window.ERPlineNative yo'q) hech narsa qilmaydi: veb sahifa fonda
// joylashuvni ishonchli bera olmaydi.
export default function CourierTrackingInit() {
  const isAuth = useSelector(s => s.auth.isAuthenticated);
  const isCourier = useSelector(s => !!s.auth.user?.isCourier);
  const shift = useCourierShift();

  // Kirganda serverdan ochiq smenani o'qiymiz (ilova qayta ochilsa ham davom etadi).
  useEffect(() => {
    if (isAuth && isCourier) loadShift(); else resetShift();
  }, [isAuth, isCourier]);

  useEffect(() => {
    const native = window.ERPlineNative;
    if (!native || (isAuth && isCourier && !shift.loaded)) return;
    try {
      const token = localStorage.getItem('token');
      if (isAuth && isCourier && shift.active && token) native.postMessage('startTracking:' + JSON.stringify({ api: API_URL, token }));
      else native.postMessage('stopTracking');
    } catch { /* ignore */ }
  }, [isAuth, isCourier, shift.loaded, shift.active]);

  return null;
}
